import { Link } from "react-router-dom";
import { UnfoldHamburgerMenu } from "./components/unfolding_hamburger_menu.js";
import { Timeline } from "./components/timeline.js";
import { SummeryCards } from "./components/summery_cards.js";

import React, { useState } from "react";

export function LandingPage() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
        <div className="top-links">
          <a href="https://github.com/Eliya-G">
            <img
              className="svg-glow block-left-padding top-link-icon"
              src="/tech_icons/github.svg"
              alt="Github"
              height="35px"
              width="35px"
            />
          </a>
          <a href="https://www.linkedin.com/in/eliya-gopkalo/">
        <img className="svg-glow top-link-icon" src="/tech_icons/linkedin.svg" alt="" height="30px" width="30px"/>
          </a>
          <img
            src={menuOpen?"/tech_icons/x-symbol.svg":"/tech_icons/hamburger_menu.svg"}
            alt="Mobile menu hamburger"
            className="block-left-padding svg-glow external-icon hamburger-menu"
            onClick={() => setMenuOpen(!menuOpen)}
          />
          <a href="mailto:eliya.gop1@gmail.com">
            <img className="svg-glow top-link-icon" src="/tech_icons/email.svg" alt="" height="35px" width="40px"/>
          </a>

          <a href="tel:6478609006">
          <img
          className="svg-glow top-link-icon"
          src="/tech_icons/phone.svg"
          alt="Phone"
          height="35px"
          width="35px"
          />
          </a>
        </div>
        <img src="./images/splash_image.png" alt="Phoenix image" className="logo" />
        <div className="hidden-ham-menu">
          <UnfoldHamburgerMenu isOpen={menuOpen} />
        </div>
        <div className="container-box">
          <h1 className="hero-text">Hi, my name is Eliya Gopkalo</h1>
          <p className="normal-glow-text">
            I'm a full-stack developer with experience designing and deploying
            responsive, cross-platform web applications. Proficient in
            Next.js, React, Python, and RESTful APIs, with a focus on
            building clean, maintainable code. Skilled in private database
            management, dynamic UI development, and secure backend integration.
            Independently deployed and configured web servers, handling both
            application delivery and infrastructure setup.
            <img src="./images/gif_final.gif" alt="" />
          </p>
        </div>
        <div className="project-box project-box-border">
          <SummeryCards />
        </div>
        <div className="container-box ">
          <h1 className="hero-text">Experience and Projects</h1>
          <p className="normal-glow-text paragraph-spacer">
            My background combines professional development experience with
            self-driven projects that demonstrate my technical skills and
            commitment to growth. Check out my <Link to="/resume"><i className="resume-txt-link">[Resume  <img
          
          
                      className="svg-glow"
                      src="/tech_icons/arrow_loop_back.svg"
                      alt="Arrow"
                      height="15px"
                      width="15px"
                    />]
 
          </i></Link>.</p>
        </div>

        <Timeline />
        <div className="container-box">
          <p className="normal-glow-text center-text">
            Reach me at:{" "}
            <Link to="mailto:eliya.gop1@gmail.com">
              <button className="normal-glow-text bottom-buttons">
                eliya.gop1@gmail.com
              </button>
            </Link>{" "}
            |{" "}
            <Link to="tel:6478609006">
              <button className="normal-glow-text bottom-buttons">
                647-860-9006
              </button>
            </Link>
          </p>
        </div>

        <div className="external-links">
          <Link to="/resume">
            <button className="resume-btn ">Resume</button>
          </Link>
        </div>
        <div className="bottom-spacer"></div>
    </>
  );
}
